export function calculateCgpa(semesters) {
  let weightedTotal = 0;
  let totalCredits = 0;

  for (const semester of semesters) {
    const gpa = Number(semester.gpa);
    const credits = Number(semester.credits);

    if (!Number.isFinite(gpa) || gpa < 0 || gpa > 10) {
      return { error: 'Semester GPA must be between 0 and 10.' };
    }

    if (!Number.isFinite(credits) || credits <= 0 || credits > 50) {
      return { error: 'Semester credits must be greater than 0 and at most 50.' };
    }

    weightedTotal += gpa * credits;
    totalCredits += credits;
  }

  if (totalCredits <= 0) {
    return { error: 'Total semester credits must be greater than 0.' };
  }

  return {
    value: weightedTotal / totalCredits,
    totalCredits,
    weightedTotal
  };
}
